<div class="content-wrapper-inner">
    <div class="page-content">
        <app-appscripts-crypto-wallet-index></app-appscripts-crypto-wallet-index>
        <hr style="margin: 1.5rem 0">
        <div class="table-topbar mb-20">
            <div class="search-panel">
                <div class="search-control">
                    <span class="icon-search"></span>
                    <input type="search" class="form-control table-search" [formControl]="searchControl" />
                </div>
            </div>
            <div class="table-action-holder">
                <div class="create">
                    <button (click)="paymentMethodCreate()" class="btn btn-primary py-10 px-15">
                        <i class="fa fa-plus"></i> Create
                    </button>
                </div>
            </div>
        </div>
        <div class="dt-bootstrap pos-relative">
            <app-appscripts-payment-method-table (actions)="paymentMethodAction($event)"
                (changeBatch)="selectedRows = $event"></app-appscripts-payment-method-table>
        </div>
    </div>
</div>

<ng-template #formModalTpl let-dialogRef="dialogRef">
    <div class="modal-header mb-10">
        <div class="modal-title">
            <h3 *ngIf="formModel" class="d-inline-block">{{ formModel.id ? 'Update payment method' : 'Create payment method' }}</h3>
            <button type="button" class="btn-close" (click)="dialogRef.close(false)">
                <span class="icon-close"></span>
            </button>
        </div>
    </div>
    <div class="modal-body" style="min-height: 200px">
        <div [hidden]="!formLoading" class="spinner">
            <div class="sk-spinner sk-spinner-pulse"></div>
        </div>
        <app-appscripts-payment-method-form [model]="formModel" (onAfterSave)="onAfterSave()" [showButtons]="false"></app-appscripts-payment-method-form>
    </div>
    <div class="modal-footer pt-15">
        <div class="button-holder d-flex justify-content-between">
            <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
            <button [disabled]="!form || !form.form.valid || form.loading" (click)="form.onSubmit()" class="btn btn-primary">Apply</button>
        </div>
    </div>
</ng-template>
